import { render, staticRenderFns } from "./linkEvent.vue?vue&type=template&id=c5691e7c&scoped=true"
import script from "./linkEvent.vue?vue&type=script&lang=js"
export * from "./linkEvent.vue?vue&type=script&lang=js"
import style0 from "./linkEvent.vue?vue&type=style&index=0&id=c5691e7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5691e7c",
  null
  
)

export default component.exports